export const SHOW_MULTI_PDP_VISITS = 'SHOW_MULTI_PDP_VISITS';
export const SHOW_PDP_SOURCING = 'SHOW_PDP_SOURCING';
export const SHOW_PDP_TRADE_ONBOARDING = 'SHOW_PDP_TRADE_ONBOARDING';
export const SHOW_PDP_TRADE_DESIGN_MANAGER_PRO_ONBOARDING =
    'SHOW_PDP_TRADE_DESIGN_MANAGER_PRO_ONBOARDING';
export const SHOW_PDP_TRADE_DESIGN_MANAGER_STANDARD_ONBOARDING =
    'SHOW_PDP_TRADE_DESIGN_MANAGER_STANDARD_ONBOARDING';
export const SHOW_PDP_TRADE_NEGOTIATION_TOAST = 'SHOW_PDP_TRADE_NEGOTIATION_TOAST';
export const SHOW_PDP_TRADE_HOLD_REQUEST_TOAST = 'SHOW_PDP_TRADE_HOLD_REQUEST_TOAST';
export const SHOW_PDP_TRADE_NEGOTIATION_MODAL = 'SHOW_PDP_TRADE_NEGOTIATION_MODAL';
export const SHOW_PDP_TRADE_ON_APPROVAL_CALLOUT = 'SHOW_PDP_TRADE_ON_APPROVAL_CALLOUT';

export const PRIORITIES = {
    MULTI_PDP_VISITS: 345,
    PDP_SOURCING: 450,
    PDP_TRADE_ONBOARDING: 350,
    PDP_TRADE_MICRO_GOALS: 340,
    PDP_TRADE_DESIGN_MANAGER_ONBOARDING: 347,
};

export const NOTIFICATION_KEYS = {
    MULTI_PDP_VISITS: 'multiPdpVisits',
    PDP_SOURCING_MODAL: 'pdpSourcingModal',
    PDP_TRADE_ONBOARDING_MODAL: 'pdpTradeOnboardingModal',
    PDP_TRADE_DESIGN_MANAGER_PRO_ONBOARDING: 'pdpTradeDesignManagerProOnboardingModal',
    PDP_TRADE_DESIGN_MANAGER_STANDARD_ONBOARDING: 'pdpTradeDesignManagerStandardOnboardingModal',
    /* trade micro goals */
    PDP_TRADE_NEGOTIATION_TOAST: SHOW_PDP_TRADE_NEGOTIATION_TOAST,
    PDP_TRADE_HOLD_REQUEST_TOAST: SHOW_PDP_TRADE_HOLD_REQUEST_TOAST,
    PDP_TRADE_NEGOTIATION_MODAL: SHOW_PDP_TRADE_NEGOTIATION_MODAL,
    PDP_TRADE_ON_APPROVAL_CALLOUT: SHOW_PDP_TRADE_ON_APPROVAL_CALLOUT,
};
